import { EventBus } from "../../events";
import axios from "axios";
import * as Sentry from "@sentry/vue";
export default {
  data() {
    return {
      fetch_data: this.$route.params,
      countryCodeDropDown: false,
      showCountryCodeFlag: false,
      number: false,
      changeValue: false,
      countryList: [
        {
          key: "+91",
          value: "India (+91)",
          countryCode: "IN",
        },
        {
          key: "+65",
          value: "Singapore (+65)",
          countryCode: "SG",
        },
        {
          key: "+60",
          value: "Malaysia (+60)",
          countryCode: "MY",
        },
        {
          key: "+966",
          value: "Saudi Arabia (+966)",
          countryCode: "SA",
        },
      ],
    };
  },

  methods: {
    setOption() {
      this.countryCodeDropDown = !this.countryCodeDropDown;
    },

    showCountryCode(username) {
      //remove spaces for the provide value
      let valueWithoutSpaces = username.trim().split(" ").join("");
      let filter = /^[0-9-+]+$/;

      //test if the username or username without spaces is a number
      if (filter.test(username) || filter.test(valueWithoutSpaces)) {
        this.number = true;
        this.showCountryCodeFlag = true;
        this.fetch_data.username = valueWithoutSpaces;
        this.phoneInput.number = this.fetch_data.username;
      } else {
        this.number = false;
        this.showCountryCodeFlag = false;
      }
      this.$forceUpdate();
    },

    setDefaultIsdCode() {
      this.fetch_data.isdcode = this.fetch_data.isdcode || "+91";
      this.fetch_data.countryCode = this.fetch_data.countryCode || "in";
      this.$forceUpdate();
    },
  },
  watch: {
    countryCodeDropDown: function (newValue, oldValue) {
      EventBus.$emit("isd_drop_down", oldValue);
    },
  },
  beforeMount() {
    window.addEventListener("beforeunload", function () {
      localStorage.removeItem("ipCodeExecuted");
    });
  },
  beforeDestroy() {
    localStorage.removeItem("ipCodeExecuted");
  },
  async mounted() {
    let isIpCodeExecuted = JSON.parse(localStorage.getItem("ipCodeExecuted"));

    //check if fetch_data has isdCode. if yes then do not call api. [only if this if block is not executed before]
    if (
      !this.fetch_data.hasOwnProperty("isdcode") &&
      !this.fetch_data.isdcode &&
      !isIpCodeExecuted
    ) {
      try {
        //saving flag to localstorage
        localStorage.setItem("ipCodeExecuted", true);
        const axleClient = axios.create({
          baseURL: window.env.API_GATEWAY
        });
        const ipUrlEndPoint = window.env.IPIFY_URL || null;
        if (ipUrlEndPoint) {
          const ipResponse = await axios.get(ipUrlEndPoint).catch((err) => {
            Sentry.withScope((scope) => {
              scope.setTag("pageUrl", window.location.href);
              scope.setTag("Application", "ACCOUNTS");
              Sentry.captureMessage(`IPIFY FETCH IP ADDRESS FAILED ${err}`, {
                level: "error",
              });
            });
            return {
              data: {
                ip: "49.43.42.169",
              },
            };
          });
          const { ip } = ipResponse.data;
          if (ip) {
            const ipDetect = await axleClient
              .get("/livspace-web-backend/v1/geoip/", {
                params: {
                  ip,
                  skipDb: true,
                },
              })
              .catch((err) => {
                Sentry.withScope((scope) => {
                  scope.setTag("pageUrl", window.location.href);
                  scope.setTag("Application", "ACCOUNTS");
                  Sentry.captureMessage(`FAILED TO GET GOE LOCATION ${err}`, {
                    level: "error",
                  });
                });
                return {
                  data: {
                    ip: "49.43.42.169",
                    isoCode: "IN",
                    countryName: "India",
                  },
                };
              });
            let code =
              ipDetect && ipDetect.data && ipDetect.data.isoCode
                ? ipDetect.data.isoCode.toLowerCase()
                : "in";
            let countryArr = await this.countryList.filter(
              (country) => country.countryCode === code.toUpperCase()
            );
            if (countryArr.length) {
              this.fetch_data.isdcode = countryArr[0].key;
              this.fetch_data.countryCode =
                countryArr[0].countryCode.toLowerCase();
              this.phoneInput.initialisationOptions.initialCountry =
                this.fetch_data && this.fetch_data.countryCode;
              this.$forceUpdate();
            } else {
              //country not found, so set it to default
              this.setDefaultIsdCode();
            }
          } else {
            //set +91 as default if ip is not returned by ipify
            this.setDefaultIsdCode();
          }
          this.$forceUpdate();
        } else {
          //set +91 as default if ipify end point is not found
          this.setDefaultIsdCode();
        }
      } catch (err) {
        //set default as fallback value
        this.setDefaultIsdCode();
      }
    }
  },

  // const ip =
  // (req.headers['x-forwarded-for'] && req.headers['x-forwarded-for'].split(',').pop()) || // From proxy headers, can be spoofed if you don't have a proxy in front of your app, so drop it if your app is naked.
  // req.connection.remoteAddress ||
  // req.connection.socket.remoteAddress
};
